import { Typography } from '@/components/Typography'
import { Button } from '@/components/buttons/Button'
import { DashboardExperiments } from '@/experiments'
import { useFlag } from '@/hooks/useFlag'
import { usePremiumFeaturesPaymentIssue } from '@/stores/permissions/premiumFeatures'
import { colors } from '@/styles/colors'
import { SUPPORT_MARQII_URL } from '@/utils/constants/supportMarqii'
import { format } from 'date-fns'
import { Trans, useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

export const PaymentIssueWarningBanner = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'components.paymentIssueWarningBanner',
  })

  const shouldEnforceBillingFoundations = useFlag(
    DashboardExperiments.shouldEnforceBillingFoundations,
  )

  const premiumFeaturesPaymentIssue = usePremiumFeaturesPaymentIssue()

  const shouldWarn = premiumFeaturesPaymentIssue?.shouldWarn
  const gracePeriod = premiumFeaturesPaymentIssue?.gracePeriod

  const handlePaymentClick = () => {
    window.open(
      'https://payments.marqii.com/p/login/6oE7vefvc3BYaS4288',
      '_blank',
      'noopener,noreferrer',
    )
  }

  if (shouldEnforceBillingFoundations && premiumFeaturesPaymentIssue && gracePeriod) {
    const formattedDueDate = format(new Date(gracePeriod), 'MMMM d, yyyy')

    return (
      <div
        className={styles.container}
        style={{
          backgroundColor: shouldWarn ? colors.warning : colors.danger,
        }}
      >
        <Typography.Text className={styles.text}>
          <Trans
            i18nKey={'components.paymentIssueWarningBanner.title'}
            values={{ dueDate: formattedDueDate }}
            components={{
              strong: <strong />,
              a: (
                <a
                  style={{ color: 'white', textDecoration: 'underline' }}
                  href={SUPPORT_MARQII_URL}
                  target="_blank"
                  rel="external"
                />
              ),
            }}
          />
        </Typography.Text>

        <Button type="primary" onClick={handlePaymentClick} className={styles.button}>
          {t('actions.updatePayment')}
        </Button>
      </div>
    )
  }

  return null
}
